export const homeFaqs = [
  {
    question: 'Who installs pavers near me?',
    answer: 'Parkside Pavers provides professional paver installation services for patios, driveways, and outdoor living spaces throughout Tampa Bay. They serve local homeowners and commercial clients with custom designs and durable materials tailored to each specific project.',
  },
  {
    question: 'How much does paver installation cost?',
    answer: 'Paver installation costs vary based on project size, material selection, and design complexity. Most projects are priced after a free on-site evaluation to ensure an accurate estimate based on your specific layout, materials, and scope of work.',
  },
  {
    question: 'How long does a paver project take?',
    answer: 'Most paver installations take a few days to a couple of weeks depending on project size and scope. Weather conditions, design complexity, and site preparation can also affect the timeline. Parkside Pavers will give you a clear schedule during your consultation.',
  },
  {
    question: 'Are pavers better than concrete?',
    answer: 'Pavers offer superior durability, flexibility, and visual appeal compared to poured concrete. They are less prone to cracking, easier to repair if damage occurs, and available in a wide range of styles and colors to complement any home.',
  },
  {
    question: 'Is Parkside Pavers licensed and insured?',
    answer: 'Yes. Parkside Pavers is fully licensed, bonded, and insured. The company was founded by a certified ICPI (Interlocking Concrete Pavement Institute) installer, ensuring all work meets industry standards and best practices.',
  },
  {
    question: 'Do you offer free estimates?',
    answer: 'Absolutely. Parkside Pavers offers free design consultations and estimates on all paving projects — from driveways and walkways to patios and pool decks. Contact us today to schedule your free on-site evaluation.',
  },
];

export const patioFaqs = [
  {
    question: 'How long does a patio installation take?',
    answer: 'Most patio projects are completed within several days to a week depending on size, layout complexity, and site preparation requirements. Parkside Pavers will provide a detailed timeline at your free consultation.',
  },
  {
    question: 'Are paver patios better than concrete?',
    answer: 'Paver patios offer better durability, design flexibility, and visual appeal. They are less prone to cracking than poured concrete and easier to repair — individual pavers can be replaced without disturbing the entire surface.',
  },
  {
    question: 'What paver materials do you use for patios?',
    answer: 'Parkside Pavers works with premium brands including Belgard and Tremron, offering a wide range of styles, textures, and colors to match your home and landscaping. All materials are selected for Florida climate durability.',
  },
];

export const drivewayFaqs = [
  {
    question: 'How long does a driveway paver installation take?',
    answer: 'Most driveway installations are completed within 3 to 7 days depending on the size and scope. This includes base preparation, installation, and finishing — Parkside Pavers will give you a precise timeline after the site evaluation.',
  },
  {
    question: 'Will pavers crack or shift in Florida heat?',
    answer: 'Quality interlocking pavers are specifically designed to handle Florida\'s heat and humidity. Proper base preparation and installation techniques prevent shifting. Parkside Pavers follows ICPI installation standards to ensure long-term stability.',
  },
  {
    question: 'Can paver driveways handle heavy vehicles?',
    answer: 'Yes. Properly installed paver driveways can handle the weight of regular passenger vehicles as well as heavier vehicles. The interlocking design distributes weight evenly, providing excellent load-bearing performance.',
  },
];

export const locationFaqs: Record<string, { question: string; answer: string }[]> = {
  tampa: [
    {
      question: 'Who installs pavers in Tampa?',
      answer: 'Parkside Pavers provides professional paver installation services throughout Tampa, offering custom patios, driveways, walkways, pool decks, and outdoor living spaces for residential and commercial properties.',
    },
    {
      question: 'How do I get a free estimate for paver work in Tampa?',
      answer: 'Simply contact Parkside Pavers by phone at 813-404-6313 or fill out the online estimate request form. A team member will schedule a free on-site consultation at your Tampa property.',
    },
  ],
  'st-petersburg': [
    {
      question: 'Does Parkside Pavers serve St. Petersburg?',
      answer: 'Yes. Parkside Pavers regularly serves homeowners and businesses throughout St. Petersburg, FL, providing custom paver installations for driveways, patios, walkways, and pool decks.',
    },
    {
      question: 'How long does paver installation take in St. Pete?',
      answer: 'Project timelines vary by scope, but most residential paver projects in the St. Petersburg area are completed within a few days to two weeks. Parkside Pavers provides a detailed schedule at your free consultation.',
    },
  ],
  clearwater: [
    {
      question: 'Who does paver installation in Clearwater?',
      answer: 'Parkside Pavers serves Clearwater and the surrounding Pinellas County area with professional paver installation for driveways, patios, pool decks, retaining walls, and custom outdoor living spaces.',
    },
    {
      question: 'Can pavers handle Clearwater\'s coastal environment?',
      answer: 'Absolutely. Premium interlocking pavers are an excellent choice for coastal Florida environments. They handle humidity, salt air, and temperature fluctuations far better than poured concrete surfaces.',
    },
  ],
  'tarpon-springs': [
    {
      question: 'Does Parkside Pavers work in Tarpon Springs?',
      answer: 'Yes. Parkside Pavers serves Tarpon Springs and surrounding communities, providing quality paver installation for patios, driveways, walkways, and outdoor living projects.',
    },
    {
      question: 'What types of paver projects do you do in Tarpon Springs?',
      answer: 'Parkside Pavers handles all types of hardscape projects in Tarpon Springs including driveway pavers, custom patios, pool decks, walkways, retaining walls, and complete outdoor living spaces.',
    },
  ],
};
